'use client';

import { ReactNode, createContext } from 'react';
import { uuidv7 } from 'uuidv7';
import type { StorefrontCategory } from '@/api/menu-list/storefront-menu-snapshot.types';

export const CategoryContext = createContext<{ data: StorefrontCategory }>({
    data: {
        name: {
            CS: 'Kategorie',
            EN: 'Category',
        },
        assets: [],
        children: [],
        id: uuidv7(),
        itemHashes: [],
        public: true,
        sortIndex: 0,
        parentId: null,
    },
});

type Props = {
    value: {
        data: StorefrontCategory;
    };
    children?: ReactNode;
};

export const CategoryProvider = ({ value, children }: Props) => {
    return <CategoryContext.Provider value={value}>{children}</CategoryContext.Provider>;
};
